import { parseAttrs } from '../tools';

export const rxfn = /(fn)([-_a-zA-Z0-9]+)/;
/* eslint-disable-next-line camelcase */
export const fntag_fnnum = [/\[/, rxfn, /\]/];

function getfnnum(fnnum, state, block) {
  if (block) fnnum = 1 + state.fn.length;
  else fnnum = 1 + state.fncnt++;
  return fnnum;
}
export function parseifn(fnnum, state, p) {
  fnnum = getfnnum(fnnum, state);
  makeAnchor(state, '[' + fnnum + ']', {
    href: '#fn-' + fnnum, id: 'fnret-' + fnnum, class: 'sup',
  });
}
export function parsebfn(fnnum, state, p) {
  fnnum = getfnnum(fnnum, state, 1);
  state.startTag('div',
    Object.assign({ iTex: p.i, id: 'fn-' + fnnum }, parseAttrs(p.bclass, p.balign, null, state)),
    { alt: p.match, hardOpen: p.bdot.length > 1, type: 'b', fn: 1 });
  makeAnchor(state, '[' + fnnum + ']', { iTex: p.i, href: '#fnret-' + fnnum });
  state.log(' ');
}
function makeAnchor(state, txt, attrs) {
  state.startTag('a', attrs, { type: 'i' });
  state.log(txt);
  state.closeTag('i', 'a');
}
